<div class="u-margin-top-20 o-flex o-flex--align-items-center">
  <div class="o-flex o-flex--justify-center o-flex--align-items-center">
    <mat-label class="visualization__label-before-slide u-margin-right-5">Default error function</mat-label>
    <mat-slide-toggle (ngModelChange)="changeLockStatus()" [ngModel]="lockStatus">Custom error function</mat-slide-toggle>
  </div>
</div>
